<template>
    <div
        v-if="!acceptCookie"
        class="group fixed bottom-4 left-0 right-0 z-50 mx-auto flex max-w-[22rem] items-center rounded-12 bg-cookie-banner px-5 py-3 opacity-90 backdrop-blur-sm max-md:flex-col md:bottom-12 md:max-w-[55.875rem] md:space-x-5">
        <div class="relative flex shrink-0 items-center justify-center">
            <picture>
                <source
                    type="image/webp"
                    srcset="/assets/images/ui/objects/webp/cup-steam.webp" />
                <img
                    loading="lazy"
                    width="312"
                    height="266"
                    alt="анимированный пар от кружки кофе"
                    src="/assets/images/ui/objects/jpg-png/cup-steam.png"
                    class="absolute aspect-[312/266] h-16 w-auto animate-cookie-steam" />
            </picture>
            <picture>
                <img
                    class="aspect-[88/128] h-auto w-full max-w-[88px]"
                    loading="lazy"
                    width="88"
                    height="128"
                    decoding="async"
                    srcset="
                        /assets/images/ui/icons/jpg-png/cookie-small.png 1x,
                        /assets/images/ui/icons/jpg-png/cookie@2x.png    2x
                    "
                    src="/assets/images/ui/icons/jpg-png/cookie-small.png"
                    alt="Cookie Icon" />
            </picture>
        </div>

        <div class="space-y-3 max-md:mt-5">
            <p class="text-20/120 font-semibold text-ash-200">
                Мы используем файлы cookie
            </p>

            <p class="text-16/150 font-medium text-accent-100">
                Для лучшей работы сайта и сбора аналитики. Используя сайт, вы
                соглашаетесь с
                <NuxtLink
                    to="/pdf/soglasie.pdf"
                    target="_blank"
                    class="underline transition-colors duration-300 group-hover:text-accent-400"
                    >политикой обработки персональных данных.</NuxtLink
                >
            </p>
        </div>

        <AtomButton
            type="button"
            class="max-h-11 leading-none max-md:mt-3 md:self-end"
            @click="handleAccept">
            Хорошо
        </AtomButton>
    </div>
</template>

<script setup lang="ts">
import AtomButton from '~/components/atom/atom-button/AtomButton.vue'

const acceptCookie = useCookie<boolean>('acceptCookie', {
    maxAge: 60 * 60 * 24 * 7,
})

function handleAccept() {
    acceptCookie.value = true
}
</script>
